import React, { Suspense, useEffect, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";
import * as THREE from "three";

const Model = ({ path }) => {
  const { scene } = useGLTF(path);

  const model = React.useMemo(() => {
    const cloned = scene.clone(true);

    const box = new THREE.Box3().setFromObject(cloned);
    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());

    cloned.position.sub(center);

    const maxDim = Math.max(size.x, size.y, size.z);
    const scale = 1.5 / maxDim;
    cloned.scale.setScalar(scale);

    return cloned;
  }, [scene]);

  return <primitive object={model} />;
};


const ThreeDCard = ({ title, price, reviews, path }) => {
  return (
    <div style={{ width: 250, margin: 20 }}>
      <div
        style={{
          width: "100%",
          height: "300px",
          position: "relative", // Important for Canvas absolute positioning
          borderRadius: "10px",
          overflow: "hidden",
          background: "#eee",
          border: "1px solid #ddd",
        }}
      >
        <Canvas
          camera={{ position: [0, 0, 3], fov: 35 }}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "#999", // fallback background
          }}
        >
          <ambientLight intensity={1} />
          <directionalLight position={[5, 5, 5]} intensity={1} />
          <Suspense fallback={null}>
            <Model path={path} />
          </Suspense>
          <OrbitControls
            enableZoom={false}
            enablePan={false}
            autoRotate
            autoRotateSpeed={1.5}
            maxPolarAngle={Math.PI / 2}
            minPolarAngle={Math.PI / 2}
          />
        </Canvas>
      </div>

      <p style={{ margin: "8px 0 0", fontSize: 14, color: "#888" }}>T-Shirt</p>
      <h3 style={{ margin: "4px 0" }}>{title}</h3>
      <p style={{ fontWeight: "bold" }}>${price}</p>
      <p style={{ fontSize: 12, color: "#888" }}>⭐ {reviews}+ reviews</p>
    </div>
  );
};

export default ThreeDCard;
